module.exports = __webpack_public_path__ + "static/img/20005D_1_C_20210117_fit.9894d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20005D_1_C_20210117_fit.png
// module id = lZ46
// module chunks = 0